import type {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import axios from "@/src/modules/core/lib/axios";
import type {GetListResponse, GetResponse, ParamsOptions} from "@/src/modules/core/types";

import type {
  VehicleCheck,
  VehicleCheckConfirmPayload,
  VehicleCheckCreatePayload,
  VehicleCheckCreateResponse,
  VehicleCheckLookupPayload,
  VehicleCheckStatusPayload,
} from "../types";

class VehicleChecksApi extends CoreApi {
  createVehicleCheck(
    payload: VehicleCheckCreatePayload,
  ): Promise<AxiosResponse<GetResponse<VehicleCheckCreateResponse>>> {
    return super.create("vehicle-checks", payload);
  }

  lookupVehicleCheck(
    checkId: number,
    payload: VehicleCheckLookupPayload,
  ): Promise<AxiosResponse<GetResponse<VehicleCheckCreateResponse>>> {
    return axios({
      url: `vehicle-checks/${checkId}/lookup`,
      method: "post",
      data: payload,
    });
  }

  confirmVehicleCheck(
    checkId: number,
    payload: VehicleCheckConfirmPayload,
  ): Promise<AxiosResponse<GetResponse<VehicleCheck>>> {
    return super.update("vehicle-checks", checkId, payload);
  }

  updateVehicleCheckStatus(
    checkId: number,
    payload: VehicleCheckStatusPayload,
  ): Promise<AxiosResponse<GetResponse<VehicleCheck>>> {
    return super.update("vehicle-checks", checkId, payload);
  }

  getVehicleChecks(options?: ParamsOptions): Promise<AxiosResponse<GetListResponse<VehicleCheck>>> {
    return this.search("vehicle-check", options);
  }

  getVehicleCheck(
    checkId: number,
    options?: ParamsOptions,
  ): Promise<AxiosResponse<GetResponse<VehicleCheck>>> {
    return this.getById("vehicle-checks", checkId, options);
  }
}

export const vehicleChecksApi = new VehicleChecksApi();
